import { render, staticRenderFns } from "./QuestionInput.vue?vue&type=template&id=98e04e3a&scoped=true&"
import script from "./QuestionInput.vue?vue&type=script&lang=js&"
export * from "./QuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./question-input.scss?vue&type=style&index=0&id=98e04e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e04e3a",
  null
  
)

export default component.exports